<template>
  <div>
    <div class="mb-4">
      <p class="font-weight-medium">{{ $t('message.agentApplicationApproved') }}</p>
      <p class="font-weight-medium">{{ $t('message.acceptAgentTnc') }}</p>
    </div>
    <div v-html="agentTermsAndConditions" class="scrollable-text-section" />
    <v-card-actions class="d-flex flex-row justify-space-between ma-auto mt-10">
      <v-btn color="primary" outlined class="rounded-pill text-capitalize override-disabled-styles" style="width: 30%" @click="tncAgreement(2)">
        {{ $t('button.decline') }}
      </v-btn>
      <v-btn color="primary" class="px-6 rounded-pill green-gradient-right text-capitalize override-disabled-styles" style="width: 30%" @click="tncAgreement(1)">
        {{ $t('button.accept') }}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { localeHelper } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters('page', ['agentTermsAndConditions'])
  },
  methods: {
    ...mapActions('agent', ['sendTncAgreement']),
    async tncAgreement(action) {
      await this.sendTncAgreement({ agree_on_agenttnc: action })
        .then((res) => {
          if (res.agree_on_agenttnc === false) {
            if (res.message) this.$toast.error(res.message)
            this.$emit('close')
          } else {
            this.$emit('next-step')
          }
        })
        .catch((err) => {
          this.$toast.error(err.error_message)
        })
    }
  }
}
</script>
